@if (progressSegments.length > 0) {
<div class="graphParent flex-header-graph">
  <div class="graph-container">
    <div class="graphCenter" [style.min-width]="width" [style.height]="height">
      @for (segment of progressSegments; track segment.key) {
      <div
        [class.space]="applySpaceClass"
        class="graph"
        tooltipPosition="bottom"
        [pTooltip]="segment.statusText + ' ' + getRoundedPercentage(segment.percentage)"
        [style.width]="segment.percentage"
        [style.backgroundColor]="segment.color"></div>
      }
    </div>
  </div>
</div>
}
